import { IAuthModel } from '@api/auth/models/body/auth.model'
import { IAuthExternalDto } from '../models/dto/auth-external.dto'

export const parseAuthExternal = (
  authExternal: IAuthExternalDto
): IAuthModel => {
  return {
    space: authExternal.space,
    domain: authExternal.domain,
    userName: authExternal.userName,
    loginData: {
      password: authExternal.password,
    },
  }
}
